export const LOGIN_SUCCESS = "AUTH:LOGIN_SUCCESS"
export const LOGIN_FAILURE = "AUTH:LOGIN_FAILURE"
export const LOGIN_REQUEST = "AUTH:LOGIN_REQUEST"

export const LOGOUT = 'LOGOUT';

export const FORGOT_PASSWORD_FAILURE = "FORGOT:FORGOT_PASSWORD_FAILURE"
export const FORGOT_PASSWORD_SUCCESS = "FORGOT:FORGOT_PASSWORD_SUCCESS"
export const FORGOT_PASSWORD_REQUEST = "FORGOT:FORGOT_PASSWORD_REQUEST"

export const GET_DISTRIBUTOR_SUCCESS = "GETDISTRIBUTOR:GET_DISTRIBUTOR_SUCCESS"
export const GET_DISTRIBUTOR_FAILURE = "GETDISTRIBUTOR:GET_DISTRIBUTOR_FAILURE"
export const GET_DISTRIBUTOR_REQUEST = "GETDISTRIBUTOR:GET_DISTRIBUTOR_REQUEST"


export const UPDATE_PASSWORD_FAILURE = "UPDATE:UPDATE_PASSWORD_FAILURE"
export const UPDATE_PASSWORD_SUCCESS = "UPDATE:UPDATE_PASSWORD_SUCCESS"
export const UPDATE_PASSWORD_REQUEST = "UPDATE:UPDATE_PASSWORD_REQUEST"

export const DUPLICATE_USER_ID_CHECK_REQUEST = "DUPLICATEUSERID: DUPLICATE_USER_ID_CHECK_REQUEST"
export const DUPLICATE_USER_ID_CHECK_SUCCESS = "DUPLICATEUSERID:DUPLICATE_USER_ID_CHECK_SUCCESS"
export const DUPLICATE_USER_ID_CHECK_FAILURE = "DUPLICATEUSERID: DUPLICATE_USER_ID_CHECK_FAILURE"

export const VERIFY_EMAIL_STEP_ONE_REQUEST =
  "VERIFYEMAIL:VERIFY_EMAIL_STEP_ONE_REQUEST";
export const VERIFY_EMAIL_STEP_ONE_SUCCESS =
  "VERIFYEMAIL:VERIFY_EMAIL_STEP_ONE_SUCCESS";
export const VERIFY_EMAIL_STEP_ONE_FAILURE =
  "VERIFYEMAIL:VERIFY_EMAIL_STEP_ONE_FAILURE";

export const VERIFY_EMAIL_STEP_TWO_REQUEST =
  "VERIFYEMAIL:VERIFY_EMAIL_STEP_TWO_REQUEST";
export const VERIFY_EMAIL_STEP_TWO_SUCCESS =
  "VERIFYEMAIL:VERIFY_EMAIL_STEP_TWO_SUCCESS";
export const VERIFY_EMAIL_STEP_TWO_FAILURE =
  "VERIFYEMAIL:VERIFY_EMAIL_STEP_TWO_FAILURE";

export const GET_AFFILIATE_INFO = 'GET_AFFILIATE_REQUEST';

export const CREATE_ACCOUNT_REQUEST = "CREATE_ACCOUNT_REQUEST";
export const CREATE_ACCOUNT_SUCCESS = "CREATE_ACCOUNT_SUCCESS";
export const CREATE_ACCOUNT_FAILURE = "CREATE_ACCOUNT_FAILURE";

export const GET_SCORECARD_REQUEST = "SCORECARD:GET_SCORECARD_REQUEST";
export const GET_SCORECARD_SUCCESS = "SCORECARD:GET_SCORECARD_SUCCESS";
export const GET_SCORECARD_FAILURE = "SCORECARD:GET_SCORECARD_FAILURE";


export const GET_SCORECARDCHART_REQUEST = "SCORECARD:GET_SCORECARDCHART_REQUEST";
export const GET_SCORECARDCHART_SUCCESS = "SCORECARD:GET_SCORECARDCHART_SUCCESS";
export const GET_SCORECARDCHART_FAILURE = "SCORECARD:GET_SCORECARDCHART_FAILURE";

export const GET_AGGREGATED_DATA_REQUEST = 'DASHBOARD: GET_AGGREGATED_DATA_REQUEST'
export const GET_AGGREGATED_DATA_SUCCESS = 'DASHBOARD: GET_AGGREGATED_DATA_SUCCESS'
export const GET_AGGREGATED_DATA_FAILURE = 'DASHBOARD: GET_AGGREGATED_DATA_FAILURE'

export const GET_OPEN_CASES_REQUEST = 'DASHBOARD: GET_OPEN_CASES_REQUEST'
export const GET_OPEN_CASES_SUCCESS = 'DASHBOARD: GET_OPEN_CASES_SUCCESS'
export const GET_OPEN_CASES_FAILURE = 'DASHBOARD: GET_OPEN_CASES_FAILURE'

export const GET_NOTIFICATIONS_REQUEST = 'DASHBOARD: GET_NOTIFICATIONS_REQUEST'
export const GET_NOTIFICATIONS_SUCCESS = 'DASHBOARD: GET_NOTIFICATIONS_SUCCESS'
export const GET_NOTIFICATIONS_FAILURE = 'DASHBOARD: GET_NOTIFICATIONS_FAILURE'

export const GET_AGENT_PRODUCT_REQUEST = 'LANDING PAGE: GET_AGENT_PRODUCT_REQUEST'
export const GET_AGENT_PRODUCT_SUCCESS = 'LANDING PAGE: GET_AGENT_PRODUCT_SUCCESS'
export const GET_AGENT_PRODUCT_FAILURE = 'LANDING PAGE: GET_AGENT_PRODUCT_FAILURE'

export const GET_USER_PERSONA_REQUEST = 'LOGIN: GET_USER_PERSONA_REQUEST'
export const GET_USER_PERSONA_SUCCESS = 'LOGIN: GET_USER_PERSONA_SUCCESS'
export const GET_USER_PERSONA_FAILURE = 'LOGIN: GET_USER_PERSONA_FAILURE'

export const GET_AGGREGATED_DATA_DIST_REQUEST = 'DASHBOARD: GET_AGGREGATED_DATA_DIST_REQUEST'
export const GET_AGGREGATED_DATA_DIST_SUCCESS = 'DASHBOARD: GET_AGGREGATED_DATA_DIST_SUCCESS'
export const GET_AGGREGATED_DATA_DIST_FAILURE = 'DASHBOARD: GET_AGGREGATED_DATA_DIST_FAILURE'

export const GET_SCORECARD_DIST_REQUEST = 'SCORECARD: GET_SCORECARD_DIST_REQUEST'
export const GET_SCORECARD_DIST_SUCCESS = 'SCORECARD: GET_SCORECARD_DIST_SUCCESS'
export const GET_SCORECARD_DIST_FAILURE = 'SCORECARD: GET_SCORECARD_DIST_FAILURE'

export const GET_AGENT_LIST_REQUEST = 'DASHBOARD: GET_AGENT_LIST_REQUEST'
export const GET_AGENT_LIST_SUCCESS = 'DASHBOARD: GET_AGENT_LIST_SUCCESS'
export const GET_AGENT_LIST_FAILURE = 'DASHBOARD: GET_AGENT_LIST_FAILURE'

export const GET_OPEN_CASES_DIST_REQUEST = 'DASHBOARD: GET_OPEN_CASES_DIST_REQUEST'
export const GET_OPEN_CASES_DIST_SUCCESS = 'DASHBOARD: GET_OPEN_CASES_DIST_SUCCESS'
export const GET_OPEN_CASES_DIST_FAILURE = 'DASHBOARD: GET_OPEN_CASES_DIST_FAILURE'

export const GET_AFFILIATE_LOGIN_INFO_REQUEST = 'LANDING: GET_AFFILIATE_LOGIN_INFO_REQUEST'
export const GET_AFFILIATE_LOGIN_INFO_SUCCESS = 'LANDING: GET_AFFILIATE_LOGIN_INFO_SUCCESS'
export const GET_AFFILIATE_LOGIN_INFO_FAILURE = 'LANDING: GET_AFFILIATE_LOGIN_INFO_FAILURE'

export const GET_OTP_REQUEST = 'LOGIN: GET_OTP_REQUEST'
export const GET_OTP_SUCCESS = 'LOGIN: GET_OTP_SUCCESS'
export const GET_OTP_FAILURE = 'LOGIN: GET_OTP_FAILURE'

export const VALIDATE_OTP_REQUEST = 'LOGIN: VALIDATE_OTP_REQUEST'
export const VALIDATE_OTP_SUCCESS = 'LOGIN: VALIDATE_OTP_SUCCESS'
export const VALIDATE_OTP_FAILURE = 'LOGIN: VALIDATE_OTP_FAILURE'

export const GET_SCORECARDCHART_PERSONA_REQUEST = "SCORECARD:GET_SCORECARDCHART_PERSONA_REQUEST";
export const GET_SCORECARDCHART_PERSONA_SUCCESS = "SCORECARD:GET_SCORECARDCHART_PERSONA_SUCCESS";
export const GET_SCORECARDCHART_PERSONA_FAILURE = "SCORECARD:GET_SCORECARDCHART_PERSONA_FAILURE";

export const GET_AGENCYPRODUCTLIST_PERSONA_REQUEST = "FILTERS: GET_AGENCYPRODUCTLIST_PERSONA_REQUEST";
export const GET_AGENCYPRODUCTLIST_DISTRIBUTOR_PERSONA_SUCCESS = "FILTERS: GET_AGENCYPRODUCTLIST_DISTRIBUTOR_PERSONA_SUCCESS";
export const GET_AGENCYPRODUCTLIST_AGENCY_PERSONA_SUCCESS = "FILTERS: GET_AGENCYPRODUCTLIST_AGENCY_PERSONA_SUCCESS";
export const GET_AGENCYPRODUCTLIST_PRODUCT_PERSONA_SUCCESS = "FILTERS: GET_AGENCYPRODUCTLIST_PRODUCT_PERSONA_SUCCESS";
export const GET_AGENCYPRODUCTLIST_PERSONA_FAILURE = "FILTERS: GET_AGENCYPRODUCTLIST_PERSONA_FAILURE";

export const SSO_LOGIN_SUCCESS = "AUTH: SSO_LOGIN_SUCCESS"
export const SSO_LOGIN_FAILURE = "AUTH: SSO_LOGIN_FAILURE"
export const SSO_LOGIN_REQUEST = "AUTH: SSO_LOGIN_REQUEST"

export const HUBSPOT_TICKET_SUCCESS = "APP MANAGEMENT: HUBSPOT_TICKET_SUCCESS"
export const HUBSPOT_TICKET_FAILURE = "APP MANAGEMENT: HUBSPOT_TICKET_FAILURE"
export const HUBSPOT_TICKET_REQUEST = "APP MANAGEMENT: HUBSPOT_TICKET_REQUEST"